import { gsap } from "gsap";
import { SplitText } from "../../plugins/gsap/SplitText";

gsap.registerPlugin(SplitText);

class HeroBioShows {
    constructor() {
        this.initTypingAnimation();
    }

    initTypingAnimation() {
        const heroText = document.querySelector('.hero-bio-shows__text');
        if(heroText) {
            const split = new SplitText(heroText, {type:"lines,words,chars", charsClass: 'js-letter'});

            const heroTitleChars = split.chars;

            heroTitleChars.forEach(function (t) {
                return t.innerHTML = '<div class="js-inner">' + t.innerHTML + "</div>"
            });

            gsap.set(heroText, {perspective:400, opacity: 1});
            gsap.from('.hero-bio-shows__text .js-inner', {duration: 0.5, y: "120%", stagger: 0.15, delay: 0.5});
        }
    }
}

export default HeroBioShows;
